import React from 'react';
import { Link } from 'react-router-dom';

const UserHome = () => {
  return (
    <div>
      <h1>User Home</h1>
      <Link to="/userslist">
        <button>Go to user List</button>
      </Link>
      <br />
      <Link to="/usersadd">
        <button>Add a user</button>
      </Link>
      <br />
      <Link to="/usersdelete">
        <button>Delete a user </button>
      </Link>
      <br />
      <Link to="/usersupdate">
        <button>Update a user </button>
      </Link>
    </div>
  );
};

export default UserHome;
